/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { Button, Box } from '@mui/material/';
import { FaPrint, FaBan } from 'react-icons/fa';
import { get } from 'lodash';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import PdfDocument from './Invoice';
// import InvoiceData from './InvoiceData';

export default function MyDocument() {
  const tableDatas = 'viagens';
  const { id } = useParams();
  const fileName = `Viagem-${id}.pdf`;
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setTable] = useState([]);

  useEffect(() => {
    async function getData() {
      try {
        setIsLoading(true);
        const response = await axios.get(`/${tableDatas}/${id}`);
        setTable(response.data);
      } catch (err) {
        const status = get(err, 'response.status', 0);
        const errors = get(err, 'response.data.errors', []);

        if (status === 400) errors.map((error) => toast.error(error));
        navigate(`/home`);
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [navigate, id]);

  return (
    <ContainerGrid>
      <Title>Relatório de Viagens</Title>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '5px',
        }}
      >
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ padding: 0 }}
        >
          <PDFDownloadLink
            document={<PdfDocument dados={data} />}
            fileName={fileName}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            {({ loading }) =>
              loading ? (
                <FaBan
                  size="12"
                  color="white"
                  style={{ minWidth: '1em', minHeight: '1em' }}
                />
              ) : (
                <FaPrint
                  size="12"
                  color="white"
                  style={{ minWidth: '1em', minHeight: '1em' }}
                />
              )
            }
          </PDFDownloadLink>
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(-1)}
        >
          Fechar
        </Button>
      </Box>
      <PDFViewer width={920} height={1150} showToolbar={false}>
        <PdfDocument dados={data} />
      </PDFViewer>
      <Loading isLoading={isLoading} />
    </ContainerGrid>
  );
}
